<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalSafeValues",
	components: { CaseForm },
	computed: {
		schema() {
			return [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>6. What will be the MAXIMUM VALUE of all watches, jewellery, gold, bullion, and platinum goods, precious stones and pearls (including those in windows) OUT OF LOCKED SAFE OR STRONGROOM?</div>"
					},
					bindTo: ""
				},
				{
					label: "Outside business hours",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0WatchesBusinessHoursMaxValueId",
					props: {
						suggest: {
							typeIncludes: "stuffBusinessHoursMaxValue"
						},
						createOptions: {
							type: "stuffBusinessHoursMaxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "During temporary closing e.g. Lunch Time (if applicable)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0WatchesLunchTimeMaxValueId",
					props: {
						suggest: {
							typeIncludes: "stuffLunchTimeMaxValue"
						},
						createOptions: {
							type: "stuffLunchTimeMaxValue",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
